import(/* webpackMode: "eager", webpackExports: ["SlugContainer"] */ "/app/src/app/(shop)/[slug]/components/slugContainer.tsx");
